import React from 'react';

import { Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

export default function ConversationComplete({ customerName }) {
  return (
    <div className="d-f fd-c mb-24">
      {customerName && (
        <Text
          variant={TEXT_VARIANTS.BODY}
          className="OnDemandPracticeConversation-customerTyping mt-24 mb-24 fs-i"
          component="div"
        >
          {t('practice.on_demand_practice.conversation.left_chat', {
            customerName,
          })}
        </Text>
      )}
      <div className="OnDemandPracticeConversation-lesson-completed Animated--fadeIn d-f fd-c ai-c jc-c w-fill mt-8">
        <Icon
          className="OnDemandPracticeConversation-lesson-completed-icon"
          name="thumbsup_sparkle"
        />
        <Text className="mt-16" variant={TEXT_VARIANTS.TITLE_BOLD}>
          {t('practice.on_demand_practice.conversation.great_job')}
        </Text>
        <Text variant={TEXT_VARIANTS.SUBHEADER}>
          {t('practice.on_demand_practice.conversation.chat_saved')}
        </Text>
      </div>
    </div>
  );
}
